<template>
  <div id="app">
    <router-view :key="viewKey"/>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'; // 确保你安装了 lodash

export default {
  data() {
    return {
      isMobile: false,
      initialHeight: window.innerHeight,
    };
  },
  computed: {
    viewKey() {
      return this.isMobile ? 'mobile' : 'desktop';
    }
  },
  mounted() {
    this.checkIsMobile();
    this.debouncedCheckIsMobile = debounce(this.checkIsMobile, 300);
    window.addEventListener('resize', this.debouncedCheckIsMobile);
  },
  methods: {
    checkIsMobile() {
      const newHeight = window.innerHeight;
      const newIsMobile = window.innerWidth <= 768;

      // 如果视口高度发生了变化且设备类型没有发生改变，可能是软键盘导致的
      if (Math.abs(newHeight - this.initialHeight) > 100 && this.isMobile === newIsMobile) {
        return; // 如果是软键盘事件，不做任何处理
      }

      if (this.isMobile !== newIsMobile) {
        this.isMobile = newIsMobile;
        this.handleNavigation();
      }

      // 更新初始高度
      this.initialHeight = newHeight;
    },
    handleNavigation() {
      const targetName = this.isMobile ? 'MobileHome' : 'HomeView';
      if (this.$route.name !== targetName) {
        this.$router.replace({ name: targetName });
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.debouncedCheckIsMobile);
  }
};
</script>

<style lang="scss" scoped>
#app {
  width: 100vw;
  height: 100vh;
  color: #2c3e50;
}

@media screen and (max-width: 750px){
  .el-message-box{
    width: 80% !important;
  }
}
</style>
